module.exports = __webpack_public_path__ + "static/media/weather-2.2eaf65e6.svg";